package br.com.logicalside.proposes.components.layouts

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem

@Composable
fun InnerContainer(modifier: Modifier = Modifier, content: @Composable () -> Unit) {
    Box(InnerContainerStyle.toModifier().then(modifier), contentAlignment = Alignment.Center) {
        Box(InnerContentStyle.toModifier()) {
            content()
        }
    }
}

val InnerContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth()
}

val InnerContentStyle = CssStyle {
    base { Modifier.fillMaxSize() }
    Breakpoint.MD { Modifier.maxWidth(60.cssRem) }
}
